import { StyledContent } from '@/components/styles'

const TitleContentBlock = ({ data }) => {
  const { content: htmlContent } = data

  return (
    <StyledContent.Description>
      <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} dark/>
    </StyledContent.Description>
  )
}

export default TitleContentBlock
